var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8H16V7.41421C16 7.29283 15.9853 7.17296 15.9568 7.057C15.9525 7.03943 15.9479 7.02195 15.943 7.00458L15.9417 7C15.8721 6.75786 15.742 6.53488 15.5607 6.35355L11.6458 2.43867C11.4646 2.25769 11.2418 2.12781 11 2.05832C10.8665 2.01996 10.7272 2 10.5858 2H6C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H8.22126L8.20776 17.9744C8.092 17.7508 8.01983 17.5018 8.00293 17.2392C7.99787 17.1606 7.99776 17.0807 8.00293 17H6C5.44772 17 5 16.5523 5 16V4C5 3.44772 5.44772 3 6 3H10V6.5C10 7.32843 10.6716 8 11.5 8ZM11.5 7C11.2239 7 11 6.77614 11 6.5V3.20711L14.7929 7H11.5ZM14.8092 9.54776C15.5395 8.81741 16.7237 8.81741 17.454 9.54776C18.1843 10.2781 18.1843 11.4622 17.454 12.1926L12.6246 17.022C12.343 17.3036 11.9902 17.5033 11.6039 17.5999L10.106 17.9744C9.45456 18.1372 8.86451 17.5472 9.02737 16.8958L9.40184 15.3979C9.49842 15.0116 9.69818 14.6588 9.97975 14.3772L14.8092 9.54776Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.03925bce7a23d45dafd252dca03c316a.svg";
export { ForwardRef as ReactComponent };